import {getTypesByInterest} from "@/api/list";
import {IList} from "@/interfaces";
import {useEffect, useState} from "react";

export const useStarTypesByInterestList = (country: number, interests: number[]) => {
	const [starTypesList, setStarsList] = useState<IList[]>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		setLoading(true);
		getTypesByInterest(country, interests)
			.then((response) => {
				setStarsList(response.data);
				setError(null);
			})
			.catch((err) => {
				setError(err);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [interests]);

	return {starTypesList, loading, error};
}
